import React from 'react';
import { IconProps } from '../../types/icon';

const TotalProjectsIcon: React.FC<IconProps> = ({ className, width = 48, height = 49 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 48 49" 
      fill="none"
      className={className}
    >
  <g clipPath="url(#clip0_1_2177)">
    <path d="M47.9157 22.034C46.9417 20.726 45.4477 19.974 43.8157 19.974H42.9297V16C42.9297 10.486 38.4437 5.99995 32.9297 5.99995H22.8177C22.5097 5.99995 22.1977 5.92595 21.9237 5.78995L15.6137 2.63395C14.7857 2.21995 13.8577 2.00195 12.9297 2.00195H8.92969C4.51769 1.99995 0.929688 5.58795 0.929688 9.99995V36C0.929688 41.514 5.41569 46 10.9297 46H36.0457C40.4977 46 44.3457 43.136 45.6497 38.786L48.7137 26.554C49.1817 24.99 48.8897 23.344 47.9157 22.034ZM4.92969 36V9.99995C4.92969 7.79395 6.72369 5.99995 8.92969 5.99995H12.9297C13.2377 5.99995 13.5497 6.07395 13.8237 6.20995L20.1337 9.36595C20.9617 9.77995 21.8897 9.99795 22.8177 9.99795H32.9297C36.2377 9.99795 38.9297 12.69 38.9297 15.998V19.972H18.1597C14.7597 19.972 11.7237 22.13 10.5817 25.412L6.20169 39.688C5.40569 38.67 4.92969 37.39 4.92969 36ZM44.8577 25.494L41.7937 37.724C41.0257 40.282 38.7157 42 36.0457 42H10.9297C10.5137 42 10.1077 41.958 9.71569 41.876L14.3837 26.658C14.9417 25.052 16.4617 23.974 18.1617 23.974H43.8177C44.3017 23.974 44.5837 24.254 44.7077 24.422C44.8317 24.59 45.0197 24.94 44.8577 25.494Z" fill="url(#paint0_linear_1_2177)"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M4.92969 9.99799V35.998C4.92969 37.388 5.40569 38.668 6.20169 39.686L10.5817 25.41C11.7237 22.128 14.7597 19.97 18.1597 19.97H38.9297V15.996C38.9297 12.688 36.2377 9.99599 32.9297 9.99599H22.8177C21.8897 9.99599 20.9617 9.77799 20.1337 9.36399L13.8237 6.20799C13.5497 6.07199 13.2377 5.99799 12.9297 5.99799H8.92969C6.72369 5.99799 4.92969 7.79199 4.92969 9.99799Z" fill="url(#paint1_linear_1_2177)" fillOpacity="0.3"/>
  </g>
  <defs>
    <linearGradient id="paint0_linear_1_2177" x1="0.929687" y1="24.001" x2="48.9322" y2="24.001" gradientUnits="userSpaceOnUse">
      <stop stopColor="#22FE78"/>
      <stop offset="1" stopColor="#0081FE"/>
    </linearGradient>
    <linearGradient id="paint1_linear_1_2177" x1="24.9309" y1="40.9999" x2="24.9309" y2="9.99994" gradientUnits="userSpaceOnUse">
      <stop stopColor="#17D1A8" stopOpacity="0"/>
      <stop offset="1" stopColor="#17D1A8"/>
    </linearGradient>
    <clipPath id="clip0_1_2177">
      <rect width="48" height="48" fill="white" transform="translate(0.929688)"/>
    </clipPath>
  </defs>
</svg>
  );
};

export default TotalProjectsIcon;